<script setup lang="ts">
    interface Props {
        readonly source?: string;
    }

    defineProps<Props>();
</script>

<template>
    <div class="quiz-footer">
        <p
            v-if="source"
            class="question-source"
        >
            {{ source }}
        </p>
        <NuxtLink
            class="pflichtangaben-link"
            to="https://medice-health-family.com/de-de/fachportal/pflichtangaben"
            external
        >
            Pflichtangaben
        </NuxtLink>
    </div>
</template>

<style scoped>
    .quiz-footer {
        --quiz-footer-background: #e8f0f5;
        --quiz-footer-color: #3f5d6b;
        --quiz-footer-link-color: #006779;
        --quiz-footer-spacing: 4px;
        --quiz-footer-inline-padding: 12px;

        display: flex;
        flex-direction: column;
        align-items: center;
        gap: var(--quiz-footer-spacing);
        padding: var(--quiz-footer-spacing) var(--quiz-footer-inline-padding);
        background: var(--quiz-footer-background);
        text-align: center;
        overflow-wrap: anywhere;
    }

    .question-source,
    .pflichtangaben-link {
        margin: 0;
        font-size: 14px;
        line-height: 1.5;
        color: var(--quiz-footer-color);
    }

    .pflichtangaben-link {
        display: inline-flex;
        align-items: center;
        min-height: 44px;
        color: var(--quiz-footer-link-color);
        text-decoration: underline;
        text-underline-offset: 3px;
    }

    .pflichtangaben-link:hover {
        text-decoration-thickness: 2px;
    }

    .pflichtangaben-link:focus-visible {
        outline: 2px solid currentColor;
        outline-offset: 3px;
    }

    .pflichtangaben-link:active {
        color: var(--quiz-footer-color);
    }
</style>
